import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchProjects, fetchTechnologies, fetchProjectCategories } from '../../services/api';
import { createProject, updateProject, deleteProject, reorderProjects, uploadImage } from '../../services/adminApi';
import { useCrudResource } from '../../hooks/useCrudResource';
import Button from '../../components/admin/ui/Button';
import Loader from '../../components/admin/ui/Loader';
import EntityTable from '../../components/admin/EntityTable';
import EntityForm from '../../components/admin/EntityForm';
import EntityFormPage from '../../components/admin/EntityFormPage';
import AdminProjectsSubnav from '../../components/admin/AdminProjectsSubnav';
import { getProjectColumns, getProjectFields, projectToPayload } from '../../config/admin/projects.config';

function AdminProjectsPage({ showToast }) {
  const navigate = useNavigate();
  const { items: projects, loading, reload, createItem, removeItem } = useCrudResource(
    { fetchAll: fetchProjects, create: createProject, update: updateProject, remove: deleteProject },
    { showToast, entityLabel: 'Projet' }
  );

  const [categories, setCategories] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [view, setView] = useState('list');

  useEffect(() => {
    fetchProjectCategories().then((data) => setCategories(data ?? []));
    fetchTechnologies().then((data) => setTechnologies(data?.items ?? []));
  }, []);

  const handleDeleteProject = async (project) => {
    if (!window.confirm('Supprimer ce projet ?')) return;
    await removeItem(project.id);
  };

  const handleReorderProjects = async (ids) => {
    await reorderProjects(ids);
    await reload();
  };

  const handleImageUpload = async (file) => {
    const result = await uploadImage(file);
    return result.path;
  };

  const handleCreateSubmit = async (values) => {
    await createItem(projectToPayload(values));
    setView('list');
  };

  if (loading) return <Loader label="Chargement des projets..." />;

  if (view === 'form') {
    return (
      <EntityFormPage listLabel="Projets" title="Ajouter un projet" onBack={() => setView('list')}>
        <EntityForm
          fields={getProjectFields(technologies, categories)}
          initialValues={{ category: categories[0]?.id, technologyIds: [], images: [] }}
          onSubmit={handleCreateSubmit}
          onUpload={handleImageUpload}
          submitLabel="Créer"
        />
      </EntityFormPage>
    );
  }

  return (
    <section className="admin-section">
      <h2>Projets</h2>
      <AdminProjectsSubnav />

      <div className="admin-actions" style={{ justifyContent: 'flex-end', marginBottom: 'var(--space-3)' }}>
        <Button onClick={() => setView('form')}>+ Ajouter un projet</Button>
      </div>
      <EntityTable
        columns={getProjectColumns(categories)}
        rows={projects}
        onEdit={(project) => navigate(`/admin-bj/projets/${project.seturl}`)}
        onDelete={handleDeleteProject}
        onReorder={handleReorderProjects}
        emptyMessage="Aucun projet."
        searchPlaceholder="Rechercher un projet..."
        searchFilter={(row, needle) =>
          (row.nom?.fr || '').toLowerCase().includes(needle) ||
          (row.nom?.en || '').toLowerCase().includes(needle) ||
          (row.seturl || '').toLowerCase().includes(needle)
        }
      />
    </section>
  );
}

export default AdminProjectsPage;
